module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              (_vm.showRechnungerstellen = true) && (_vm.rechnungErstellenData = _vm.rechnungErstellenDataMaske)
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Neue Rechnung")])]), _vm._v(" "), (_vm.rechnungsKategorienen[_vm.tab]) ? _c('span', [_c('dialogRechnungenVersenden', {
    attrs: {
      "visible": _vm.showRechnungenVersenden,
      "rechnungen": _vm.alleRechnungen.filter(function (item) { return item.status === _vm.rechnungsKategorienen[_vm.tab].status; })
    },
    on: {
      "update:visible": function($event) {
        _vm.showRechnungenVersenden = $event
      },
      "close": function($event) {
        _vm.showRechnungenVersenden = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showSepaDateien = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("request_quote")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Sepa Dateien")])])], 1), _vm._v(" "), _c('v-toolbar-items', [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.showExport = !_vm.showExport
            }
          }
        }, on), [_c('v-icon', [_vm._v("file_download")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Export")])])], 1), _vm._v(" "), _c('v-toolbar-items', [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.showStatistik = !_vm.showStatistik
            }
          }
        }, on), [_c('v-icon', [_vm._v("insights")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Statistik")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-container', [_vm._v("\n    " + _vm._s(_vm.kasse ? "" : "Rechnungen konnten nicht geladen werden. Bitte zur Startseite gehen.") + "\n    "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-tabs', {
    staticClass: "mb-2",
    attrs: {
      "center-active": "",
      "show-arrows": "",
      "background-color": "transparent"
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [(_vm.rechnungsKategorienen.length === 0) ? _c('v-tab', [_vm._v("Keine Rechnungen vorhanden")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rechnungsKategorienen), function(item) {
    return (item.anzahl > 0) ? _c('v-tab', {
      key: item.status,
      staticClass: "caption"
    }, [_vm._v(_vm._s(item.status) + " (" + _vm._s(item.anzahl) + ")")]) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex justify-end align-center",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-responsive', {
    staticClass: "mr-4",
    attrs: {
      "max-width": "300"
    }
  }, [_c('v-text-field', {
    staticClass: "rounded-lg",
    attrs: {
      "dense": "",
      "flat": "",
      "solo": "",
      "hide-details": "",
      "append-icon": "search",
      "placeholder": "Rechnungen durchsuchen",
      "clearable": ""
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.search = ''
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-card', {
    staticClass: "rounded-lg"
  }, [_c('v-tabs-items', {
    staticClass: "transparent",
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.rechnungsKategorienen), function(item) {
    return (item.anzahl > 0) ? _c('v-tab-item', {
      key: item.status
    }, [_c('rechnungen-liste', {
      attrs: {
        "status": item.status,
        "kasse": _vm.kasse,
        "search": _vm.search
      }
    })], 1) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "40%",
      "height": "100%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showExport),
      callback: function($$v) {
        _vm.showExport = $$v
      },
      expression: "showExport"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Export Rechnungen " + _vm._s(_vm.kasse) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showExport = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Die Rechnungen werden derzeit ausschließlich mit UTF-8 exportiert. Daher ist die csv-Datei evtl nicht in allen\n        Tabellenprogrammen gleich dargestellt.\n      ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showExport = false
      }
    }
  }, [_vm._v("Schließen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.exportData()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("file_download")]), _vm._v("Daten herunterladen")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%",
      "height": "100%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showStatistik),
      callback: function($$v) {
        _vm.showStatistik = $$v
      },
      expression: "showStatistik"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("\n        Zusammenfassung Rechnungspositionen\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showStatistik = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-row', {
    staticClass: "mt-4 mb-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "filter.von",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "label": "Datum von",
            "readonly": ""
          },
          model: {
            value: (_vm.formatDatumVon),
            callback: function($$v) {
              _vm.formatDatumVon = $$v
            },
            expression: "formatDatumVon"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu3),
      callback: function($$v) {
        _vm.menu3 = $$v
      },
      expression: "menu3"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu3 = false
      }
    },
    model: {
      value: (_vm.filter.von),
      callback: function($$v) {
        _vm.$set(_vm.filter, "von", $$v)
      },
      expression: "filter.von"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "filter.von",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "label": "Datum bis",
            "readonly": ""
          },
          model: {
            value: (_vm.formatDatumBis),
            callback: function($$v) {
              _vm.formatDatumBis = $$v
            },
            expression: "formatDatumBis"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu4),
      callback: function($$v) {
        _vm.menu4 = $$v
      },
      expression: "menu4"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu4 = false
      }
    },
    model: {
      value: (_vm.filter.bis),
      callback: function($$v) {
        _vm.$set(_vm.filter, "bis", $$v)
      },
      expression: "filter.bis"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n            Diese Ansicht zeigt eine Zusammenfassung der Rechnungspositionen aller gezahlten Rechnungen der\n            " + _vm._s(_vm.kasse) + " im Zeitraum vom " + _vm._s(_vm.$filters.date(_vm.filter.von, "DD.MM.YYYY")) + " bis\n            " + _vm._s(_vm.$filters.date(_vm.filter.bis, "DD.MM.YYYY")) + ". Sie unterteilt die Rechnungen in Überweisungen und\n            Sepa-Rechnungen.\n          ")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Rechnungen per Überweisung:")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "200px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Betrag")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.positionen.normal), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.betrag)))])])
  }), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Summe")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.positionen.normal_summe)))])])], 2)])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Rechnungen per SEPA:")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "200px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Betrag")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.positionen.sepa), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.betrag)))])])
  }), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Summe")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.positionen.sepa_summe)))])])], 2)])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showStatistik = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "70%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.showRechnungerstellen),
      callback: function($$v) {
        _vm.showRechnungerstellen = $$v
      },
      expression: "showRechnungerstellen"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl pa-0 ma-0",
    attrs: {
      "height": "80vh"
    }
  }, [_c('v-card-title', [_vm._v("\n        Rechnungen erstellen\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        (_vm.showRechnungerstellen = false) && (_vm.$vars.loading = false)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-stepper', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "flat": "",
      "outlined": "",
      "alt-labels": ""
    },
    model: {
      value: (_vm.e1),
      callback: function($$v) {
        _vm.e1 = $$v
      },
      expression: "e1"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 1,
      "step": "1"
    }
  }, [_vm._v("Kontakte"), _c('br'), _vm._v("auswählen")]), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 2,
      "step": "2"
    }
  }, [_vm._v("Rechnungs-"), _c('br'), _vm._v("details")]), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 3,
      "step": "3"
    }
  }, [_vm._v("Rechnungs-"), _c('br'), _vm._v("positionen")]), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 4,
      "step": "4"
    }
  }, [_vm._v("Zusammenfassung")]), _c('v-divider')], 1), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pt-4",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "deletable-chips": "",
      "multiple": "",
      "chips": "",
      "small-chips": "",
      "clearable": "",
      "required": "",
      "outlined": "",
      "clear-icon": "delete",
      "items": _vm.bundesbruder,
      "label": "Kontakte auswählen"
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-chip', {
          attrs: {
            "small": "",
            "label": ""
          }
        }, [_vm._v(_vm._s(_vm.rechnungErstellenData.bbrbbr ? _vm.rechnungErstellenData.bbrbbr.length : 0))])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.rechnungErstellenData.bbrbbr),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenData, "bbrbbr", $$v)
      },
      expression: "rechnungErstellenData.bbrbbr"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n                  Gruppen nach Mitgliedsstatus hinzufügen: "), _c('br'), _vm._v(" "), _vm._l((_vm.gruppen), function(item, index) {
    return _c('v-btn', {
      key: index,
      staticClass: "mr-2",
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.gruppeAdd(item.status)
        }
      }
    }, [_vm._v(_vm._s(item.status))])
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.gruppeAdd('Alle')
      }
    }
  }, [_vm._v("Alle")])], 2), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-icon', [_vm._v("info")]), _vm._v("\n                  Bsp: Sollen Rechnungen an einen Teil der Mitglieder gestellt werden kann einfach \"Alle\" ausgewählt\n                  werden. Im weiteren Prozess erhalten nur Kontakte, welche einen Betrag eingetragen haben eine\n                  Rechnung die mehr als 0€ beträgt. Rechnung die 0€ betragen werden nicht erstellt.\n                ")], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-card', {
    attrs: {
      "height": "480px"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pt-4 py-0",
    attrs: {
      "cols": "6",
      "md": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "required": "",
      "label": "Rechnungstitel"
    },
    model: {
      value: (_vm.rechnungErstellenData.titel),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenData, "titel", $$v)
      },
      expression: "rechnungErstellenData.titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-4 py-0",
    attrs: {
      "cols": "6",
      "md": "2"
    }
  }, [_c('v-menu', {
    ref: "rechnungErstellenData.datum",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "outlined": "",
            "label": "Rechnungsdatum",
            "readonly": ""
          },
          model: {
            value: (_vm.formatDatum),
            callback: function($$v) {
              _vm.formatDatum = $$v
            },
            expression: "formatDatum"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu1 = false
      }
    },
    model: {
      value: (_vm.rechnungErstellenData.datum),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenData, "datum", $$v)
      },
      expression: "rechnungErstellenData.datum"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-4 py-0",
    attrs: {
      "cols": "6",
      "md": "2"
    }
  }, [_c('v-menu', {
    ref: "rechnungErstellenData.zahlbar_bis",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "outlined": "",
            "label": "Zahlbar bis",
            "readonly": ""
          },
          model: {
            value: (_vm.formatZahlbar_bis),
            callback: function($$v) {
              _vm.formatZahlbar_bis = $$v
            },
            expression: "formatZahlbar_bis"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu2 = false
      }
    },
    model: {
      value: (_vm.rechnungErstellenData.zahlbar_bis),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenData, "zahlbar_bis", $$v)
      },
      expression: "rechnungErstellenData.zahlbar_bis"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-textarea', {
    attrs: {
      "rows": "12",
      "label": "Freitext",
      "hint": "<<Rechnungstitel>>, <<Rechnungsdatum>>, <<Rechnungsnummer>>, <<Briefanrede>>, <<Vorname>>, <<Nachname>>, <<Rechnungsbetrag>>, <<Zahlbar_bis>>, <<Absender Name>>",
      "outlined": ""
    },
    model: {
      value: (_vm.rechnungErstellenData.freitext),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenData, "freitext", $$v)
      },
      expression: "rechnungErstellenData.freitext"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-textarea', {
    attrs: {
      "rows": "12",
      "label": "Freitext SEPA",
      "hint": "<<Rechnungstitel>>, <<Rechnungsdatum>>, <<Rechnungsnummer>>, <<Briefanrede>>, <<Vorname>>, <<Nachname>>, <<Rechnungsbetrag>>, <<Zahlbar_bis>>, <<Absender Name>>",
      "outlined": ""
    },
    model: {
      value: (_vm.rechnungErstellenData.freitext_Sepa),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenData, "freitext_Sepa", $$v)
      },
      expression: "rechnungErstellenData.freitext_Sepa"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "height": "480px"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        (_vm.showRechnungerstellenPositionAdd = true) &&
        (_vm.rechnungErstellenPositionAddData = {
          neu: true,
          anzahl: 1,
          betrag: '',
          betragArray: []
        })
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("Position")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        (_vm.showRechnungerstellenVeranstaltungAdd = true) &&
        (_vm.rechnungerstellenVeranstaltungAddData = {
          neu: true,
          anzahl: 1,
          betrag: 0,
          betragBegleitung: 0,
          betragArray: [],
        })
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("Veranstaltung")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        (_vm.showRechnungerstellenCouleurstrafenAdd = true) &&
        (_vm.rechnungerstellenCouleurstrafenAddData = {
          neu: true,
          anzahl: 1,
          bezeichnung: 'Couleurstrafen',
          betrag: 0,
          betragArray: [],
        })
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("Couleurstrafen")], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "subtitle-2 text-right mt-2"
  }, [_vm._v("Summe: " + _vm._s(_vm._f("money")(_vm.rechnungErstellenDataSumme)))])]), _vm._v(" "), (_vm.switchTabelle.positionen) ? _c('v-col', {
    attrs: {
      "cols": _vm.switchTabelle.rechnungen ? 6 : 12
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "400"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left",
    attrs: {
      "width": "20px"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Was")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Anz")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Betrag von-bis")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Summe")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rechnungErstellenData.positionen), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rechnungen.length))]), _vm._v(" "), (item.min !== item.max) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v("\n                              " + _vm._s(_vm._f("money")(item.min)) + " - " + _vm._s(_vm._f("money")(item.max)) + "\n                            ")]) : _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.min)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.summe)))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteRechnungErstellenPosition(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.switchTabelle.rechnungen) ? _c('v-col', {
    attrs: {
      "cols": _vm.switchTabelle.positionen ? 6 : 12
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "400"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left",
    attrs: {
      "width": "20px"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Wer")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Anz Positionen")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Summe")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rechnungErstellenData.rechnungen), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbrID, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.positionen.length))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.summe)))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteRechnungErstellenRechnung(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)])], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "height": "480px"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card')], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.indexRechnung < 1
    },
    on: {
      "click": function($event) {
        _vm.indexRechnung -= 1
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center subtitle-2"
  }, [_vm._v("\n                          Rechnung " + _vm._s(_vm.indexRechnung + 1) + " von " + _vm._s(_vm.kontrolleRechnungen.length) + "\n                        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.indexRechnung > _vm.kontrolleRechnungen.length - 2
    },
    on: {
      "click": function($event) {
        _vm.indexRechnung += 1
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "200"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left",
    attrs: {
      "width": "20px"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Was")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Anzahl")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Betrag")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Summe")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kontrolleRechnungen[_vm.indexRechnung].positionen), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.betrag)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.summe)))])])
  }), 0)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-row', {
    staticClass: "my-1 mx-1 subtitle-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$filters.user(_vm.kontrolleRechnungen[_vm.indexRechnung].bbrID, _vm.bbrbbr)) + "\n                          ")]), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm._f("money")(_vm.kontrolleRechnungen[_vm.indexRechnung].summe)) + "\n                          ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showRechnungerstellen = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.e1 === 4) ? _c('div', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.e1 = _vm.e1 - 1
      }
    }
  }, [_vm._v("Zurück")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "rounded": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.rechnungErstellen()
      }
    }
  }, [_vm._v("Rechnungen stellen")])], 1) : _c('div', {
    staticClass: "text-right"
  }, [(_vm.e1 > 1) ? _c('v-btn', {
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.e1 = _vm.e1 - 1
      }
    }
  }, [_vm._v("Zurück")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "rounded": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.e1 = _vm.e1 + 1
      }
    }
  }, [_vm._v("Weiter")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "60%",
      "height": "100%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showRechnungerstellenPositionAdd),
      callback: function($$v) {
        _vm.showRechnungerstellenPositionAdd = $$v
      },
      expression: "showRechnungerstellenPositionAdd"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "height": "480px"
    }
  }, [_c('v-card-title', [_vm._v("\n        Neue Position hinzufügen\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showRechnungerstellenPositionAdd = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 pt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "label": "Bezeichnung",
      "outlined": ""
    },
    model: {
      value: (_vm.rechnungErstellenPositionAddData.bezeichnung),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenPositionAddData, "bezeichnung", $$v)
      },
      expression: "rechnungErstellenPositionAddData.bezeichnung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "type": "number",
      "label": "Anzahl",
      "outlined": ""
    },
    model: {
      value: (_vm.rechnungErstellenPositionAddData.anzahl),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenPositionAddData, "anzahl", $$v)
      },
      expression: "rechnungErstellenPositionAddData.anzahl"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "type": "number",
      "label": "Betrag",
      "outlined": ""
    },
    on: {
      "change": function($event) {
        return _vm.changePositionDataInput('betrag')
      }
    },
    model: {
      value: (_vm.rechnungErstellenPositionAddData.betrag),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenPositionAddData, "betrag", $$v)
      },
      expression: "rechnungErstellenPositionAddData.betrag"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "items": _vm.kontaktfelder,
      "label": "Kontaktfeld",
      "outlined": ""
    },
    on: {
      "change": function($event) {
        return _vm.changePositionDataInput('kontaktfeld')
      }
    },
    model: {
      value: (_vm.rechnungErstellenPositionAddData.kontaktfeld),
      callback: function($$v) {
        _vm.$set(_vm.rechnungErstellenPositionAddData, "kontaktfeld", $$v)
      },
      expression: "rechnungErstellenPositionAddData.kontaktfeld"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        return _vm.changePositionDataInput('null')
      }
    }
  }, [_vm._v("Alle 0€")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "items-per-page": _vm.rechnungErstellenPositionAddData.betragArray.length,
      "dense": "",
      "fixed-header": "",
      "height": "290",
      "hide-default-footer": "",
      "items": _vm.rechnungErstellenPositionAddData.betragArray,
      "headers": _vm.headersData
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          attrs: {
            "width": "20px"
          }
        }, [_vm._v(_vm._s(item.id + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbr, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "150px"
          }
        }, [_c('v-text-field', {
          staticClass: "text-right",
          attrs: {
            "dense": "",
            "hide-details": "",
            "prefix": "€",
            "label": "Betrag",
            "single-line": "",
            "solo": "",
            "flat": "",
            "reverse": ""
          },
          model: {
            value: (item.betrag),
            callback: function($$v) {
              _vm.$set(item, "betrag", $$v)
            },
            expression: "item.betrag"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20px"
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "pt-1",
    attrs: {
      "hide-details": "",
      "dense": "",
      "clearable": "",
      "outlined": "",
      "append-outer-icon": "add",
      "items": _vm.bundesbruder,
      "label": "Kontakt hinzufügen"
    },
    on: {
      "click:append-outer": function($event) {
        return _vm.addBbrToData()
      }
    },
    model: {
      value: (_vm.BbrToData),
      callback: function($$v) {
        _vm.BbrToData = $$v
      },
      expression: "BbrToData"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showRechnungerstellenPositionAdd = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('span', {
    staticClass: "mr-4"
  }, [_vm._v("Summe: " + _vm._s(_vm._f("money")(_vm.rechnungErstellenPositionAddDataSumme)))]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.rechnungErstellenPositionAdd()
      }
    }
  }, [_vm._v("Hinzufügen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "60%",
      "height": "100%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showRechnungerstellenVeranstaltungAdd),
      callback: function($$v) {
        _vm.showRechnungerstellenVeranstaltungAdd = $$v
      },
      expression: "showRechnungerstellenVeranstaltungAdd"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "height": "480px"
    }
  }, [_c('v-card-title', [_vm._v("\n        Veranstaltung abrechnen\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showRechnungerstellenVeranstaltungAdd = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 pt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "items": _vm.veranstaltungen,
      "label": "Veranstaltung",
      "outlined": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeVeranstaltungDataInput()
      }
    },
    model: {
      value: (_vm.rechnungerstellenVeranstaltungAddData.veranstaltung),
      callback: function($$v) {
        _vm.$set(_vm.rechnungerstellenVeranstaltungAddData, "veranstaltung", $$v)
      },
      expression: "rechnungerstellenVeranstaltungAddData.veranstaltung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "type": "number",
      "label": "Betrag",
      "outlined": ""
    },
    on: {
      "input": function($event) {
        return _vm.changeVeranstaltungDataInput()
      }
    },
    model: {
      value: (_vm.rechnungerstellenVeranstaltungAddData.betrag),
      callback: function($$v) {
        _vm.$set(_vm.rechnungerstellenVeranstaltungAddData, "betrag", $$v)
      },
      expression: "rechnungerstellenVeranstaltungAddData.betrag"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "type": "number",
      "label": "Betrag Begleitung",
      "outlined": ""
    },
    on: {
      "input": function($event) {
        return _vm.changeVeranstaltungDataInput()
      }
    },
    model: {
      value: (_vm.rechnungerstellenVeranstaltungAddData.betragBegleitung),
      callback: function($$v) {
        _vm.$set(_vm.rechnungerstellenVeranstaltungAddData, "betragBegleitung", $$v)
      },
      expression: "rechnungerstellenVeranstaltungAddData.betragBegleitung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-switch', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "label": "Füxe zahlt Fuxenkasse"
    },
    on: {
      "change": function($event) {
        return _vm.changeVeranstaltungDataInput()
      }
    },
    model: {
      value: (_vm.rechnungerstellenVeranstaltungAddData.fuxe),
      callback: function($$v) {
        _vm.$set(_vm.rechnungerstellenVeranstaltungAddData, "fuxe", $$v)
      },
      expression: "rechnungerstellenVeranstaltungAddData.fuxe"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "label": "Begleitungen sind kostenlos"
    },
    on: {
      "change": function($event) {
        return _vm.changeVeranstaltungDataInput()
      }
    },
    model: {
      value: (_vm.rechnungerstellenVeranstaltungAddData.begleitungen),
      callback: function($$v) {
        _vm.$set(_vm.rechnungerstellenVeranstaltungAddData, "begleitungen", $$v)
      },
      expression: "rechnungerstellenVeranstaltungAddData.begleitungen"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "items-per-page": _vm.rechnungerstellenVeranstaltungAddData.betragArray.length,
      "dense": "",
      "fixed-header": "",
      "height": "290",
      "hide-default-footer": "",
      "items": _vm.rechnungerstellenVeranstaltungAddData.betragArray,
      "headers": _vm.headersData
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          attrs: {
            "width": "20px"
          }
        }, [_vm._v(_vm._s(item.id + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbr, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "150px"
          }
        }, [_c('v-text-field', {
          staticClass: "text-right",
          attrs: {
            "dense": "",
            "hide-details": "",
            "prefix": "€",
            "label": "Betrag",
            "single-line": "",
            "solo": "",
            "flat": "",
            "reverse": ""
          },
          model: {
            value: (item.betrag),
            callback: function($$v) {
              _vm.$set(item, "betrag", $$v)
            },
            expression: "item.betrag"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20px"
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "pt-1",
    attrs: {
      "hide-details": "",
      "dense": "",
      "clearable": "",
      "outlined": "",
      "append-outer-icon": "add",
      "items": _vm.bundesbruder,
      "label": "Kontakt hinzufügen"
    },
    on: {
      "click:append-outer": function($event) {
        return _vm.addBbrToData()
      }
    },
    model: {
      value: (_vm.BbrToData),
      callback: function($$v) {
        _vm.BbrToData = $$v
      },
      expression: "BbrToData"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showRechnungerstellenVeranstaltungAdd = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('span', {
    staticClass: "mr-4"
  }, [_vm._v("Summe: " + _vm._s(_vm._f("money")(_vm.rechnungErstellenPositionAddDataSumme)))]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.rechnungErstellenPositionAdd()
      }
    }
  }, [_vm._v("Hinzufügen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "60%",
      "height": "100%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showRechnungerstellenCouleurstrafenAdd),
      callback: function($$v) {
        _vm.showRechnungerstellenCouleurstrafenAdd = $$v
      },
      expression: "showRechnungerstellenCouleurstrafenAdd"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "height": "480px"
    }
  }, [_c('v-card-title', [_vm._v("\n        Couleurstrafen abrechnen\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showRechnungerstellenCouleurstrafenAdd = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 pt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "label": "Bezeichnung",
      "outlined": ""
    },
    model: {
      value: (_vm.rechnungerstellenCouleurstrafenAddData.bezeichnung),
      callback: function($$v) {
        _vm.$set(_vm.rechnungerstellenCouleurstrafenAddData, "bezeichnung", $$v)
      },
      expression: "rechnungerstellenCouleurstrafenAddData.bezeichnung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.changeCouleurstrafenDataInput()
      }
    }
  }, [_vm._v("hinzufügen")])], 1), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Bitte beachte: durch Drücken des Button \"hinzufügen\" werden alle noch nicht berechneten\n                Couleurstrafen der Tabelle hinzugefügt und sofort als berechnet markiert. Das kann nicht rückgängig\n                gemacht werden.")])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "items-per-page": _vm.rechnungerstellenCouleurstrafenAddData.betragArray.length,
      "dense": "",
      "fixed-header": "",
      "height": "290",
      "hide-default-footer": "",
      "items": _vm.rechnungerstellenCouleurstrafenAddData.betragArray,
      "headers": _vm.headersData
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          attrs: {
            "width": "20px"
          }
        }, [_vm._v(_vm._s(item.id + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbr, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "150px"
          }
        }, [_c('v-text-field', {
          staticClass: "text-right",
          attrs: {
            "dense": "",
            "hide-details": "",
            "prefix": "€",
            "label": "Betrag",
            "single-line": "",
            "solo": "",
            "flat": "",
            "reverse": ""
          },
          model: {
            value: (item.betrag),
            callback: function($$v) {
              _vm.$set(item, "betrag", $$v)
            },
            expression: "item.betrag"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20px"
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "pt-1",
    attrs: {
      "hide-details": "",
      "dense": "",
      "clearable": "",
      "outlined": "",
      "append-outer-icon": "add",
      "items": _vm.bundesbruder,
      "label": "Kontakt hinzufügen"
    },
    on: {
      "click:append-outer": function($event) {
        return _vm.addBbrToData()
      }
    },
    model: {
      value: (_vm.BbrToData),
      callback: function($$v) {
        _vm.BbrToData = $$v
      },
      expression: "BbrToData"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showRechnungerstellenCouleurstrafenAdd = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('span', {
    staticClass: "mr-4"
  }, [_vm._v("Summe: " + _vm._s(_vm._f("money")(_vm.rechnungErstellenPositionAddDataSumme)))]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.rechnungErstellenPositionAdd()
      }
    }
  }, [_vm._v("Hinzufügen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showSepaDateien),
      callback: function($$v) {
        _vm.showSepaDateien = $$v
      },
      expression: "showSepaDateien"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Alle Sepa Dateien\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showSepaDateien = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-simple-table', {
    attrs: {
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Datum")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Summe")]), _vm._v(" "), _c('th', [_vm._v("Anzahl")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sepaDateien), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.date(item.date, "DD.MM.YYYY")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.filename))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.summe)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.downloadSepa(item)
        }
      }
    }, [_c('v-icon', [_vm._v("download")])], 1)], 1)])
  }), 0)]), _vm._v("\n        {{}}\n      ")], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showSepaDateien = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bbdfcbb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/rechnungen.vue
// module id = 733
// module chunks = 15